export enum CopilotPreviewContent {
  None = 0,
  Document = 1,
  Usage = 2,
}
